import React from 'react';

import { Form, Input } from 'antd';

import PhoneInput, { validPhoneNumber } from 'components/PhoneInput';
import DrawerForm from 'components/DrawerForm';
import { gql } from '@apollo/client';
import { useMutation } from 'hooks/apollo';

const UPDATE_USER = gql`
  mutation($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      firstname
      lastname
      email
      phone
    }
  }
`;

const EditUserProfile = ({ user, onCancel }) => {
  const [updateUser] = useMutation(UPDATE_USER);

  const initialValues = {
    firstname: user?.firstname,
    lastname: user?.lastname,
    phone: user?.phone,
  };

  const handleSubmit = (values) => updateUser({ variables: { input: { id: user.id, ...values } } });

  return (
    <DrawerForm open={!!user} initialValues={initialValues} formReset={user} onCancel={onCancel} onDone={onCancel} onSubmit={handleSubmit}>
      <Form.Item
        name="firstname"
        label="First name"
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="lastname"
        label="Last name"
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="phone"
        label="Phone number"
        rules={[validPhoneNumber]}
      >
        <PhoneInput />
      </Form.Item>
    </DrawerForm>
  );
};

export default EditUserProfile;
